










































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ModalNotificationUser extends Vue {
  @Prop() isActiveModalInfo: boolean

  @Inject() publishDocument
  @Inject() setActiveConfirmModal
  @Inject() goToDetail
  @Inject() clearPublish

  closeDialog() {
    this.setActiveConfirmModal(false)
    this.clearPublish()
  }
}
